<div *ngIf="disconnectedCards()?.length > 0">
  <ng-container
    *ngIf="disconnectedCards()?.length === 1 && disconnectedCards()[0]?.connection?.connectionMessages?.length < 0"
  >
    <glxy-alert
      type="warning"
      [showAction]="disconnectedCards()?.length === 1"
      actionTitle="{{ 'INTEGRATION_CARD.RECONNECT' | translate }}"
      (actionClick)="reconnectConnection()"
    >
      <span
        [innerHTML]="
          'INTEGRATION_CARD.DISCONNECT_WARNING_PROBLEM'
            | translate: { title: disconnectedCards()[0]?.integration?.displayName }
        "
      ></span>
    </glxy-alert>
  </ng-container>
  <ng-container *ngIf="disconnectedCards()?.length > 1">
    <glxy-alert type="warning">
      <span
        [innerHTML]="
          disconnectedCards()?.length === 2
            ? ('INTEGRATION_CARD.DISCONNECT_TWO_ACCOUNTS_WARNING_PROBLEM'
              | translate
                : {
                    firstTitle: disconnectedCards()[0]?.integration?.displayName,
                    secondTitle: disconnectedCards()[1]?.integration?.displayName,
                  })
            : ('INTEGRATION_CARD.DISCONNECT_MULTIPLE_ACCOUNTS_WARNING_PROBLEM'
              | translate
                : {
                    title: disconnectedCards()[0]?.integration?.displayName,
                    count: disconnectedCards()?.length - 1,
                  })
        "
      ></span>
    </glxy-alert>
  </ng-container>
</div>
